import React, { FC, useMemo } from 'react';
import { SimpleBlock, TextsPopupProps } from '@/pages/CareersPage/CareersPage.types';
import CareersPopup from '@/pages/CareersPage/components/popups/CareersPopup/CareersPopup';
import key from 'weak-key';
import classNames from 'classnames';
import styles from './TextsPopup.module.scss';

const TextsPopup: FC<TextsPopupProps> = ({
  title, backgroundImage, textBlocks, popupKey,
}) => {
  const sortedTextBlocks = useMemo(() => textBlocks.sort((a, b) => {
    const aTitle = a?.title;
    const bTitle = b?.title;

    if (!!aTitle === !!bTitle) {
      return 0;
    }

    return aTitle ? -1 : 1;
  }), [textBlocks]);

  const isSingleColumnLayout = useMemo(
    () => textBlocks.length === 1 || textBlocks.some(({ title: blockTitle }: SimpleBlock) => !blockTitle),
    [textBlocks],
  );

  const renderTextBlock = ({ title: blockTitle, description }: SimpleBlock) => {
    if (!blockTitle && !description) {
      return null;
    }

    return (
      <>
        {!!blockTitle && (
          <div className={styles.title}>{blockTitle}</div>
        )}
        {!!description && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </>
    );
  };

  const renderContainer = () => (
    <ul className={classNames(styles.container, isSingleColumnLayout && styles.singleColumnContainer)}>
      {sortedTextBlocks.map((block) => (
        <li key={key(block)} className={styles.textBlock}>{renderTextBlock(block)}</li>
      ))}
    </ul>
  );

  if (!textBlocks || !textBlocks.length) {
    return null;
  }

  return (
    <CareersPopup backgroundImage={backgroundImage} popupKey={popupKey} title={title}>
      {renderContainer()}
    </CareersPopup>
  );
};
TextsPopup.displayName = 'TextsPopup';

export default TextsPopup;
